import { render, staticRenderFns } from "./QualitySpecificationList.vue?vue&type=template&id=3f47b728&"
import script from "./QualitySpecificationList.vue?vue&type=script&lang=js&"
export * from "./QualitySpecificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports